import Banner from "../../design-system/components/Banner/Banner.jsx";
import { MODELS, useModel } from "../../api.jsx";
import Button from "../../design-system/components/Button/Button.jsx";

/**
 * Renders a demo banner with a title, message, and conditional action button based on the user's auth state.
 *
 * @return {JSX.Element} A banner component
 */
function DemoBanner() {
  const me = useModel(MODELS.ME);

  // If the user isn't logged in, we return the signInButton. If they are, and have an email (teacher or admin)
  // we return the button to directly create a workshop.
  const getActionButton = () => {
    if (!me) return <SignInButton />;
    if (me.email) return <CreateWorkshopButton />;
    return null;
  };

  // If the user isn't logged in, we prompt them to register. Else if they are teacher or admin,
  // suggest to create a Lernreise.
  const getActionText = () => {
    if (!me) return "Registriere dich kostenlos für die komplette Digital Sparks Erfahrung!";
    if (me.email) return "Erstelle deine eigene Lernreise für die komplette Digital Sparks Erfahrung!";
    return null;
  }

  return (
    <Banner
      title="✦ Demo ✦"
      message={getActionText()}
      actionButton={getActionButton()}
      closeButton={false}
    />
  );
}

export default DemoBanner;

const SignInButton = () => {
  return (
    <Button
      width="fit"
      variant="quaternary"
      onClick={() => (window.location.href = "/login")}
    >
      Anmelden
    </Button>
  );
};

const CreateWorkshopButton = () => {
  return (
    <Button
      width="fit"
      variant="quaternary"
      onClick={() => (window.location.href = "/tss/workshops/create")}
    >
      Lernreise erstellen
    </Button>
  );
};
